module.exports = __webpack_public_path__ + "static/networkerror3@3x.3698cdfc.png";